import OdiaShop from './new-odia-snacks';

function App() {
  return <OdiaShop />;
}

export default App;